module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-prefix-group"
  }, [_c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_vm._v("R$")]), _vm._v(" "), _c('money', _vm._b({
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  }, 'money', _vm.money))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf3a65f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/money-input/MoneyInput.vue
// module id = 737
// module chunks = 1